$(document).on('ready', function () {

    if ($('.eva-iframe-station-item__input').length) {
        $('.eva-iframe-station-item__input').select2({
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            dropdownParent: $('.eva-iframe'),
            language: {
                noResults: function (params) {
                    return "Нет результатов";
                }
            }
        }).on('select2:open', function (e) {
            let self = $(this);
            $('.select2-search input').prop('focus', false).prop('focus', false).attr('placeholder', self.data('search-placeholder'));
        }).on('select2:select', function (e) {
            $(e.target).data('select2').$container.addClass('selected');
        }).on('change', function (e) {
            $(e.target).data('select2').$container.addClass('selected');
        }).on('change.select2', function (e) {
            $(e.target).data('select2').$container.addClass('selected');
        });
    } else {
        $('.nf-tabs-form__group select').select2({
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            width: "100%",
            dropdownCssClass: 'nf-tabs-form-select-dropdown',
            language: {
                noResults: function (params) {
                    return "Нет результатов";
                }
            }
        }).on('select2:open', function (e) {
            let self = $(this);
            $('.select2-search input').prop('focus', false).attr('placeholder', self.data('search-placeholder'));
        });
    }

    preselectCity();

    $('.js_countable-control').on('click', function () {
        if (!$(this).attr('disabled')) {
            let self = $(this),
                func = self.data('func'),
                input = self.siblings('.js_countable-input'),
                count = parseInt(input.val());

            const min = input.data('min'),
                max = input.data('max');

            switch (func) {
                case 'dec':
                    if (count == max) {
                        enableButton(self);
                    }
                    count -= 1;
                    setValue(count, input);
                    if (count == min) {
                        disableButton(self);
                    }
                    break;
                case 'inc':
                    if (count == min) {
                        enableButton(self);
                    }
                    count += 1;
                    setValue(count, input);
                    if (count == max) {
                        disableButton(self);
                    }
                    break;
            }

            input.trigger('change');
        }
    })

    function setValue(count, input) {
        input.val(count);
    }

    function disableButton(btn) {
        btn.prop('disabled', true);
    }

    function enableButton(btn) {
        btn.siblings('button').prop('disabled', false);
    }

    $('.js_station_change').on('click', function () {
        let cityFrom = $('.js_city_from_id'),
            cityTo = $('.js_city_to_id');

        if (cityFrom.val() != 0 && cityTo.val() != 0) {
            $(this).attr('disabled', true);
            cityFrom.attr('data-changed', cityFrom.val())
                .val(cityTo.val())
                .trigger('change');
        }
    })

    $('.nf-tabs-control__item').on('click', function () {
        let self = $(this),
            id = self.data('id');
        if (!self.hasClass('is-active')) {
            self.addClass('is-active').siblings('.is-active').removeClass('is-active');
            $('.nf-tabs-item[data-id="' + id + '"]').show().siblings('.nf-tabs-item').hide();
            $('.nf-tabs-item-title[data-id="' + id + '"]').addClass('is-active').siblings('.is-active').removeClass('is-active');
        }
    })
    $('.js_test').on('click', function () {
        $('.nf-tabs-form__row--status').addClass('is-show');
    })
    $('.nf-tabs-form__row--status').on('click', function () {
        $(this).removeClass('is-show');
    })
    $('.nf-tabs-item-title').on('click', function () {
        let self = $(this),
            id = self.data('id');
        if (!self.hasClass('is-active')) {
            self.addClass('is-active').siblings('.is-active').removeClass('is-active');
            $('.nf-tabs-item[data-id="' + id + '"]').slideDown().siblings('.nf-tabs-item').slideUp();
            $('.nf-tabs-control__item[data-id="' + id + '"]').addClass('is-active').siblings('.is-active').removeClass('is-active');
        }
    })
    $('#return_flag').on('change', function () {
        let val = $(this).val();
        if (val == 1) {
            $('.js_return-ticket-date').show()
        } else {
            $('.js_return-ticket-date').hide()
        }
    })
    $('.js_custom-time').on('change', function () {
        let self = $(this);

        if (!self.is(':checked')) {
            self.closest('.nf-tabs-form__row').find('.js_time-pick').val('00:00');
        }
    })
    $('.js_time-pick').on('change', function () {
        if ( $(this).val() ) {
            if ( $('#custom-time-from').length ) {
                $('#custom-time-from').val(1);
            }
        }
    })
    if ($('.nf-tabs-control__item[data-id="booking"]').length) {
        $('.nf-tabs-control__item[data-id="booking"]').trigger('click');
    }

    function preselectCity() {
        if (getUrlParameter('from_id') && getUrlParameter('to_id')) {
            $('.js_city_from_id').attr('data-preselect', getUrlParameter('to_id'))
                .val(getUrlParameter('from_id'))
                .trigger('change');
        }
    }

    function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    }

});
